<ng-template #gotoLink>
    <app-action-router-link [actionRouterLink]="'/people'">
        <span i18n="find more colleagues text@@find-more-colleagues-text">Find more colleagues</span>
        <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-router-link>
</ng-template>

<div class="d-none d-md-block float-md-right mt-1"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>
<h2 class="widget-header h4" i18n="colleagues header@@colleagues-header">Find your colleagues</h2>
<h3 class="text-muted h6" i18n="colleagues sub header@@colleagues-sub-header">Here you find colleagues that you often interact with. Click on "Find more colleagues" to search for more colleagues and departments.</h3>
<div class="d-block d-md-none mt-2 mt-md-0"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>

<div class="row mt-4" *ngIf="myColleagues$ | async as myColleagues; else loading">
    <div class="col-12 col-sm-6 col-lg-4 mt-4 mb-4" *ngFor="let myColleague of myColleagues">
        <app-people-card [person]="myColleague"></app-people-card>
    </div>
    <div *ngIf="myColleagues.length === 0">
        <app-text-placeholder>
            <p class="text-muted" i18n="no colleagues@@no-colleagues">No colleagues found.</p>
        </app-text-placeholder>
    </div>
</div>

<ng-template #loading>
    <div class="mt-4" *ngIf="errorSubject$ | async as err; else innerLoading">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
    </div>
    <ng-template #innerLoading>
        <app-widget-placeholder>
        </app-widget-placeholder>
    </ng-template>
</ng-template>
